import { createFileRoute } from "@tanstack/react-router";
import { ComingSoon } from "@/components/layout/coming-soon";

/** Splat: nav items that are not built yet render a branded placeholder, not a 404. */
export const Route = createFileRoute("/_authenticated/admin/$")({
  component: ComingSoon,
});
